import _ from 'lodash'
import Translate from "../modules/local/Translate";
import React from "react";
import dayjs from "dayjs";
import "dayjs/locale/vi";
import {renderIfElse} from "../views/Shared";
import relativeTime from 'dayjs/plugin/relativeTime'
import isToday from 'dayjs/plugin/isToday'

// dayjs.extend(customParseFormat);
// dayjs.extend(utc);
// dayjs.extend(timezone);
// dayjs.extend(localizedFormat);
// dayjs.locale("vi");
dayjs.extend(relativeTime)
dayjs.extend(isToday)

export const timezoneAsDefault = 'Asia/Ho_Chi_Minh';

export const timezoneArray = [
    {label: "UTC−12:00", value: "Etc/GMT+12"},
    {label: "UTC−11:00", value: "Pacific/Pago_Pago"},
    {label: "UTC−10:00", value: "Pacific/Honolulu"},
    {label: "UTC−09:00", value: "America/Anchorage"},
    {label: "UTC−08:00", value: "America/Los_Angeles"},
    {label: "UTC−07:00", value: "America/Denver"},
    {label: "UTC−06:00", value: "America/Chicago"},
    {label: "UTC−05:00", value: "America/New_York"},
    {label: "UTC−04:00", value: "America/Halifax"},
    {label: "UTC−03:00", value: "America/Argentina/Buenos_Aires"},
    {label: "UTC−02:00", value: "America/Noronha"},
    {label: "UTC−01:00", value: "Atlantic/Azores"},
    {label: "UTC±00:00", value: "Europe/London"},
    {label: "UTC+01:00", value: "Europe/Berlin"},
    {label: "UTC+02:00", value: "Europe/Helsinki"},
    {label: "UTC+03:00", value: "Europe/Moscow"},
    {label: "UTC+04:00", value: "Asia/Dubai"},
    {label: "UTC+05:00", value: "Asia/Karachi"},
    {label: "UTC+06:00", value: "Asia/Dhaka"},
    {label: "UTC+07:00", value: "Asia/Ho_Chi_Minh"},
    {label: "UTC+08:00", value: "Asia/Shanghai"},
    {label: "UTC+09:00", value: "Asia/Tokyo"},
    {label: "UTC+10:00", value: "Australia/Sydney"},
    {label: "UTC+12:00", value: "Pacific/Auckland"},
];

export const convertStringToDate = (dateString, options = {}) => {
    if (!dateString || (typeof dateString !== 'string')) return null;
    const {format, strict = true} = options;

    if (format) {
        const d = dayjs(dateString, format, strict);
        return d.isValid() ? d : null;
    }

    const d1 = dayjs(dateString, 'YYYY-MM-DD', strict);
    if (d1.isValid()) return d1;

    const d2 = dayjs(dateString, 'YYYYMMDD', strict);
    if (d2.isValid()) return d2;

    const d3 = dayjs(dateString);
    return d3.isValid() ? d3 : null;
};

export const convertDateToString = (date, format = 'YYYY-MM-DDTHH:mm:ssZ') => {
    if (!date) return null; // Trả về null nếu date là null hoặc undefined

    const parsedDate = dayjs(date);

    if (!parsedDate.isValid()) return null; // Kiểm tra nếu ngày không hợp lệ

    return parsedDate.format(format);
}

export const formatSimplifyDate = (date, type, format = null) => {

    if (!date) return null;

    // 👇 parse về local time (timezone thiết bị)
    const d = dayjs(date).local();

    const currentYear = dayjs().year();
    const dateYear = dayjs(date).year();

    const isMidnight = d.hour() === 0 && d.minute() === 0; // 👈 chuẩn hơn format string

    const formats = {
        default: dateYear === currentYear ? "DD/MM" : "DD/MM/YYYY",
        medium: dateYear === currentYear ? "DD MMMM" : "DD MMMM, YYYY",
        fullShort: dateYear === currentYear ? "ddd, DD MMMM" : "ddd, DD MMMM, YYYY",
        full: dateYear === currentYear ? "HH:mm - DD MMMM" : "HH:mm - DD MMMM, YYYY",
        fullTime: dateYear === currentYear
            ? (isMidnight ? "dddd, DD MMMM" : "HH:mm - dddd, DD MMMM")
            : (isMidnight ? "dddd, DD MMMM, YYYY" : "HH:mm - dddd, DD MMMM, YYYY"),
    };

    // Nếu không có type phù hợp, dùng format mặc định "DD/MM/YYYY"
    return dayjs(date).format(formats[type] || format || formats["default"]);
}

export const isSameDay = (time1, time2) => {
    return dayjs(time1).local().isSame(dayjs(time2).local(), 'day');
};

export const formatTime = (time, timezone) => {

    if (!time || dayjs(time, "HH:mm:ss").format("HH:mm:ss") === "00:00:00") return null;

    return renderIfElse(
        timezone,
        <Translate>
            {t => (
                <span className="space-x-1">
                    <label>{dayjs(time, "HH:mm:ss").format("HH:mm")}</label>
                    <label className="font-normal text-xs text-color-300 italic">
                        {`(${t('local time')}: ${_.find(timezoneArray, {value: timezone})?.label} \u2014 ${timezone})`}
                    </label>
                </span>
            )}
        </Translate>,
        dayjs(time, "HH:mm:ss").format("HH:mm")
    );
}

export const renderDayOfWeek = (weekdays = '') => {

    let week_label;

    switch (weekdays) {
        case '1111100':
            week_label = <Translate>{t => t('from mon to fri')}</Translate>
            break;
        case '1111110':
            week_label = <Translate>{t => t('from mon to sat')}</Translate>
            break;
        case '1111111':
            week_label = <Translate>{t => t('everyday')}</Translate>
            break;
        case '0000001':
            week_label = <Translate>{t => t('sunday')}</Translate>
            break;
        default:
            let week_labels = [];
            let daily_labels = [];
            const weekdaysArr = weekdays.split("").map(Number);

            // Xử lý Chủ nhật
            if (weekdaysArr[6] === 1) {
                week_labels.push(<Translate>{t => t('sun')}</Translate>);
            }

            // Xử lý từ Thứ Hai -> Thứ Bảy
            weekdaysArr.forEach((value, index) => {
                if (index < 6 && value === 1) { // Từ Thứ Hai đến Thứ Bảy
                    daily_labels.push(index + 2); // Lấy label từ đối tượng weekdays
                }
            });

            if (!!daily_labels?.length) {
                week_labels.push(
                    <Translate>
                        {t => {
                            return `${t('Thứ')} ${daily_labels.join(", ")}`
                        }}
                    </Translate>
                )
            }
            week_label = week_labels.map((e, i) => {
                return (
                    <React.Fragment key={i}>
                        {i > 0 ? <span>, </span> : null}
                        <span key={i} className="gap-1">{e}</span>
                    </React.Fragment>
                )
            })
            break
    }

    return week_label;
}

export const isYYYYMMDDDateWeekend = (dateString) => {
    const date = dayjs(dateString.toString(), "YYYYMMDD"); // Chuyển đổi từ chuỗi thành ngày
    const dayOfWeek = date.day(); // Lấy số thứ trong tuần (0: CN, 6: T7)
    // return {
    //     date: date.format("YYYY-MM-DD"), // Format lại thành dạng YYYY-MM-DD
    //     dayName: date.format("dddd"), // Lấy tên thứ bằng ngôn ngữ mặc định
    //     isWeekend: dayOfWeek === 0 || dayOfWeek === 6 // Kiểm tra có phải T7 hoặc CN không
    // };

    return dayOfWeek === 0 || dayOfWeek === 6;
};

export const parseDate = (date) => {
    if (!date) return null; // Trả về null nếu date là null hoặc undefined

    // Thử định dạng YYYYMMDD
    const parsedDate1 = dayjs(date, "YYYYMMDD", true);
    if (parsedDate1.isValid()) return parsedDate1;

    // Thử định dạng YYYY-MM-DD
    const parsedDate2 = dayjs(date, "YYYY-MM-DD", true);
    if (parsedDate2.isValid()) return parsedDate2;

    // Nếu không hợp lệ, trả về null
    return null;
};

export const toTimeValidDayjs = (timeStr) => {
    const time = dayjs(timeStr, 'HH:mm:ss', true); // true = kiểm tra strict
    return time.isValid() ? time : null;
};

export const formatRelativeTime = (datetimeString) => {
    const date = dayjs(datetimeString)

    return date.fromNow()
}
